import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the page to the top whenever the route changes — unless the
 * URL has a `#hash`, in which case we scroll to that element instead.
 * Keeps native browser back/forward history scroll restoration intact
 * by only running on `PUSH` navigations (location.key changes).
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick so the freshly-mounted route can paint, then scroll
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: 0, behavior: "auto" });
      }, 60);
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash, key]);

  return null;
}
